import { Component, Inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoadingService } from "@coso/loading";
import { IS_SAAS } from "@coso/utility";
import { Observable } from "rxjs";
import { IConfigurationHolder } from "../../../models/auto-generated";
import { HistoryLogsService } from "../../../services/history-logs.service";
import { ReplicationService } from "../../../services/replication.service";
import { SettingsStore } from "../../../stores/settings.store";
import { handleError } from "../../../utils/handle-error";
import { isRunning } from "../../../utils/is-running";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone:false,
  templateUrl: "./logs.component.html",
  styleUrls: ["./logs.component.scss"]
})
export class LogsComponent implements OnInit {
  @ViewChild("deleteConfirmation", { static: true }) deleteConfirmation: TemplateRef<any>;
  days: number;
  shouldDeleteAll: boolean;
  modalRef: NgbModalRef;
  isRunning: boolean;
  instanceId: string;

  settings$: Observable<IConfigurationHolder>;
  errorMessage: string;
  successMessage: string;
  readonly$: Observable<boolean>;

  constructor(
    @Inject(IS_SAAS) public isSaaS: boolean,
    public loadingService: LoadingService,
    private settingsStore: SettingsStore,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private replicationService: ReplicationService,
    private historyLogsService: HistoryLogsService
  ) {}

  ngOnInit(): void {
    this.instanceId = this.route.parent.snapshot.paramMap.get("instance-id");
    this.settings$ = this.settingsStore.settings$;
    this.readonly$ = this.settingsStore.isReadOnly$;
    this.replicationService.getStatus(this.instanceId).subscribe((status) => (this.isRunning = isRunning(status)));
  }

  updateSettings(current: IConfigurationHolder) {
    this.settingsStore.updateSettings(current);
  }

  openConfirmationModal() {
    this.days = 1;
    this.shouldDeleteAll = false;
    this.modalRef = this.modalService.open(this.deleteConfirmation, {
      ariaLabelledBy: "modalTitle",
      keyboard: true,
      backdrop: "static",
      modalDialogClass: "modal-xs",
    });
  }

  clearDatabaseLogs(): void {
    this.loadingService.start("Deleting database logs");
    const days = this.shouldDeleteAll ? null : this.days;
    this.historyLogsService.clear(this.instanceId, days).subscribe(
      () => {
        this.modalRef.close();
        this.successMessage = "Logs have been successfully deleted.";
        this.loadingService.stop();
      },
      (error) => {
        this.modalRef.close();
        this.errorMessage = `Something went wrong due to: ${handleError(error)}`;
        this.loadingService.stop();
      }
    );
  }
}
